import * as swcHelpers from '@swc/helpers';
import { idleState, failedState, loadingState } from '@grandvisionhq/state';
import { FETCH_LIST_SUCCESS, FETCH_LIST_FAILED, FETCH_LIST } from './actions.js';

const initialState = {
    listCall: idleState()
};
function prescriptionsReducer(state = initialState, action) {
    switch(action.type){
        case FETCH_LIST:
            return swcHelpers.objectSpread({}, state, {
                listCall: loadingState()
            });
        case FETCH_LIST_FAILED:
            return swcHelpers.objectSpread({}, state, {
                listCall: failedState(action.error)
            });
        case FETCH_LIST_SUCCESS:
            {
                return swcHelpers.objectSpread({}, state, {
                    listCall: idleState(),
                    list: action.payload
                });
            }
        default:
            return state;
    }
}

export { initialState, prescriptionsReducer };
//# sourceMappingURL=reducer.js.map
